import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=70d5890f&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=70d5890f&lang=scss&scoped=true&"
import style1 from "./UserList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5890f",
  null
  
)

export default component.exports